module.exports = new __parcel__URL__("home.89824f63.html").toString();